export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-3d-ee70bc42d80ac0c37dc5f4afdd58a71e.webp";